import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import * as urlParse from 'url-parse';
export var DeliveryUrlHelper =
/*#__PURE__*/
function () {
  function DeliveryUrlHelper() {
    _classCallCheck(this, DeliveryUrlHelper);
  }

  _createClass(DeliveryUrlHelper, [{
    key: "replaceAssetDomain",
    value: function replaceAssetDomain(originalAssetUrl, customDomain) {
      var urlPath = this.getUrlPathname(originalAssetUrl);
      return "".concat(customDomain).concat(urlPath);
    }
  }, {
    key: "getUrlPathname",
    value: function getUrlPathname(url) {
      var parsedUrl = urlParse(url);
      return parsedUrl.pathname;
    }
  }]);

  return DeliveryUrlHelper;
}();
export var deliveryUrlHelper = new DeliveryUrlHelper();